/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
//components
//constants
//style
import './Billingpage.scss'
// import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import { useDebounce, KTSVG } from '../../../../../_metronic/helpers'
// import { startLoadding } from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
// import { GetPurchaseHistory } from './BillingSlice/BillingSlice'
import { GeneralDataOFLoginUser } from '../../../../Utils/Auth'
import NodataYet from '../../../../Components/NodataYet'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import { useLocation } from 'react-router-dom'
// import { useLazyGetDedicatedNumberTransactionsQuery } from '../../../../../services/cellcast'
import { Spinner } from 'react-bootstrap'
// import { GetCurrentData } from '../../../../Utils/_helpers/GetCurrentData'
// import { useGetDnPurchaseHistoryMutation } from '../../../../../services/cellcast.v3'
import { usePurchaseHistory } from './useBilling'

const BillingPurchaseDnTable = () => {
  const location = useLocation()

  const { isLoading, fetchHistory, isFetching, dnPurchaseHistory: purchaseHistory } = usePurchaseHistory()

  const ref = useRef<HTMLDivElement | null>(null)

  const userData = GeneralDataOFLoginUser()?.user?._id

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
    duration: 'month',
  })
  const debouncedSearchTerm = useDebounce(page?.search, 3000)

  useEffect(() => {
    AuthenticateUser('see-credit-history') &&
      fetchHistory({
        userId: userData,
        page: page.page || 1,
        size: page.size || 10,
        duration: page.duration,
        search: page.search,
        period: '',
      })
  }, [debouncedSearchTerm, userData, page.page, page.size, page.duration, page.search])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const scrollId = queryParams.get('scrollId')
    if (scrollId && scrollId === 'purchase-history' && ref.current != null) {
      const timeout = setTimeout(() => {
        if (ref.current) {
          ref.current.scrollIntoView({ behavior: 'smooth' })
        }
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [location.search])

  return (
    <>
      <div className={`card purchase-table `} ref={ref}>
        <div className='card-header border-0 pt-5 ps-5 ms-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>
              Dedicated Number Purchase History
            </span>
          </h3>
          <div className='card-toolbar'>
            <div className='nav-item pe-8 mb-1'>
              <form
                data-kt-search-element='form'
                className='w-100 position-relative'
                autoComplete='off'
              >
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-2'
                />

                <input
                  type='text'
                  className='form-control form-control-flush ps-10 rounded border-gray-200 border'
                  name='search'
                  onChange={(e: any) => {
                    setPage({ ...page, search: e.target.value })
                  }}
                  placeholder='Search...'
                  data-kt-search-element='input'
                />
              </form>
            </div>
            <ul className='nav nav-stretch  nav-line-tabs border-transparent'>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${page.duration == 'month' && 'active'
                    }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({ ...page, duration: 'month' })}
                >
                  Months
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${page.duration === 'week' && 'active'
                    }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({ ...page, duration: 'week' })}
                >
                  Week
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${page.duration == 'day' && 'active'
                    }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({ ...page, duration: 'day' })}
                >
                  Day
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${page.duration == 'all' && 'active'
                    }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({ ...page, duration: 'all' })}
                >
                  ALL
                </a>
              </li>
            </ul>
          </div>
        </div>
        {isLoading || isFetching ? (
          <div className='row flex-center h-200 mb-5'>
            <Spinner />
          </div>
        ) : (
          <>
            {purchaseHistory?.data && purchaseHistory?.data.items?.length > 0 ? (
              <div className='card-body p-0 mt-5'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200'>
                        <th className='ps-4 min-w-125px rounded-start fw-bolder'>Date</th>
                        <th className='min-w-100px fw-bolder'>Phone Number</th>
                        <th className='min-w-100px fw-bolder'>Invoice</th>
                        <th className='min-w-100px fw-bolder'>Purchase Duration</th>
                        <th className='min-w-100px fw-bolder'>Total + GST</th>
                        <th className='min-w-150px  rounded-end fw-bolder text-end pe-10 text-center'>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className='p-5'>
                      {purchaseHistory.data.items.map((data, idx: number) => (
                        <tr key={idx}>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                            <a
                              //   href='#'
                              className='d-block mb-1 fs-6'
                            >
                              {moment(data.createdAt).format('DD MMMM YYYY hh:mm')}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='d-block mb-1 fs-6'
                            >
                              {data?.number}
                            </a>
                          </td>
                          <td>
                            <pre>
                              ID : {data.stripeInvoiceNo}
                              <br />
                              Number : {data?.stripeInvoiceNumber || '-'}
                            </pre>
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            {data.recurring}
                          </td>
                          <td className='table-row-gray-200 border-bottom border-top'>
                            <a
                              //   href='#'
                              className='d-block mb-1 fs-6'
                            >
                              ${data?.deductedPrice}
                            </a>
                          </td>
                          <td className='table-row-gray-200 border-top text-end pe-5 text-center'>
                            <button
                              onClick={() => window.open(`${data.stripeInvoicePDF}`, '_self')}
                              className='btn btn-sm btn-light btn-active-light-primary fw-500'
                            >
                              Download
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message={'No invoice yet'} />
            )}
          </>
        )}
        <div className='abcd px-6'>
          {/* <select onChange={(e: any) => setPage({...page, size: e.target.value,page:1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={purchase_history?.total}>ALL</option>
                </select> */}
          <div></div>
          <ReactPaginate
            previousLabel='<'
            nextLabel='>'
            pageCount={purchaseHistory?.data?.totalPages ?? 1}
            onPageChange={(e) => setPage({ ...page, page: e.selected + 1 })}
            containerClassName={'pagiantion'}
            previousLinkClassName={'pagination__link'}
            nextLinkClassName={'pagination__link'}
            disabledClassName={'pagination__link--disabled'}
            activeClassName={'pagination__link--active'}
          />
        </div>
      </div>
    </>
  )
}

export { BillingPurchaseDnTable }
